/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function SignalsView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '960px',
        margin: '0 auto',
        padding: '24px 12px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ display: 'flex', gap: '8px' }}>
          {' '}
          {(m.sgConfChips ?? []).map((c, i48) => (
            <Fragment key={i48}>
              {' '}
              <button
                onClick={c?.go}
                title={`Minimum confidence ${dc.s(c?.label)}`}
                aria-label={`Minimum confidence ${dc.s(c?.label)}`}
                style={dc.css(
                  `font-size:11.5px;padding:6px 13px;border-radius:99px;border:1px solid ${dc.s(c?.bd)};background:${dc.s(c?.bg)};color:${dc.s(c?.fg)};cursor:pointer;font-weight:500`,
                )}
              >
                {dc.t(c?.label)}
              </button>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ flex: '1' }}></div>{' '}
        <button
          className="scp-84a7026"
          onClick={m.sgScan}
          title="Rescan the watchlist"
          aria-label="Rescan the watchlist"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '7px',
            fontSize: '12px',
            fontWeight: '500',
            padding: '8px 16px',
            borderRadius: '99px',
            border: '1px solid color-mix(in srgb, var(--acc-fill) 55%, transparent)',
            background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
            color: 'var(--acc)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-sparkle" style={{ fontSize: '13px' }}></i>
          {dc.t(m.sgScanLabel)}
        </button>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '7px' }}>
          <span style={{ fontSize: '13px', fontWeight: '500' }}>Watchlist</span>
          <span style={{ fontSize: '10.5px', color: 'var(--faint)' }}>{dc.t(m.wlCount)}</span>
        </div>{' '}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
          {' '}
          {(m.wlChips ?? []).map((w, i49) => (
            <Fragment key={i49}>
              {' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '11.5px',
                  fontWeight: '500',
                  padding: '5px 7px 5px 12px',
                  borderRadius: '99px',
                  border: '1px solid var(--l12)',
                  background: 'var(--surface)',
                }}
              >
                {dc.t(w?.sym)}
                <button
                  className="scp-e8a2319"
                  onClick={w?.remove}
                  title={`Remove ${dc.s(w?.sym)}`}
                  aria-label={`Remove ${dc.s(w?.sym)} from watchlist`}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--faint)',
                    cursor: 'pointer',
                    padding: '0',
                    display: 'flex',
                  }}
                >
                  <i className="ph ph-x" style={{ fontSize: '10px' }}></i>
                </button>
              </span>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ display: 'flex', gap: '8px', marginTop: '12px', alignItems: 'center' }}>
          {' '}
          <input
            value={dc.v(m.wlInput)}
            onChange={m.setWlInput}
            placeholder="XAUUSD"
            aria-label="Symbol to add"
            style={{
              width: '220px',
              padding: '7px 12px',
              borderRadius: '9px',
              border: '1px solid var(--l10)',
              background: 'var(--fill)',
              color: 'var(--text)',
              fontSize: '12px',
              outline: 'none',
            }}
          />{' '}
          <button
            className="scp-2223d55"
            onClick={m.wlAdd}
            title="Add symbol to watchlist"
            aria-label="Add symbol to watchlist"
            style={{
              fontSize: '11.5px',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid var(--l14)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            Add
          </button>{' '}
        </div>{' '}
        {m.wlHasErr ? (
          <>
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                marginTop: '9px',
                fontSize: '11px',
                color: 'var(--neg)',
              }}
            >
              <i className="ph ph-warning-circle" style={{ fontSize: '12px' }}></i>
              {dc.t(m.wlErr)}
            </div>{' '}
          </>
        ) : null}{' '}
      </div>{' '}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '10px',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--muted2)',
          fontWeight: '600',
        }}
      >
        Active signals · scanned 07:12
        <div
          style={{ flex: '1', height: '1px', background: 'linear-gradient(90deg,var(--l10),transparent)' }}
        ></div>
      </div>{' '}
      {m.sgScanning ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <div
                style={{ height: '13px', width: '180px', borderRadius: '99px', background: 'var(--l6)' }}
              ></div>
              <div style={{ height: '52px', borderRadius: '11px', background: 'var(--l5)' }}></div>
              <div
                style={{ height: '11px', width: '70%', borderRadius: '99px', background: 'var(--l6)' }}
              ></div>
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                opacity: '0.6',
              }}
            >
              <div
                style={{ height: '13px', width: '150px', borderRadius: '99px', background: 'var(--l6)' }}
              ></div>
              <div style={{ height: '52px', borderRadius: '11px', background: 'var(--l5)' }}></div>
            </div>{' '}
            <div style={{ textAlign: 'center', fontSize: '11px', color: 'var(--muted2)' }}>
              Scanning 5 symbols against your playbook…
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.sgHas ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {' '}
            {(m.sgList ?? []).map((s, i50) => (
              <Fragment key={i50}>
                {' '}
                <div
                  style={{
                    background: 'var(--surface)',
                    border: '1px solid var(--card-line)',
                    boxShadow: 'var(--shadow-card)',
                    borderRadius: '16px',
                    padding: '16px 18px',
                  }}
                >
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    {' '}
                    <span style={{ fontSize: '13.5px', fontWeight: '600' }}>{dc.t(s?.sym)}</span>{' '}
                    <span
                      style={dc.css(
                        `font-size:9.5px;font-weight:600;letter-spacing:0.06em;padding:3px 9px;border-radius:99px;background:${dc.s(s?.dirBg)};color:${dc.s(s?.dirFg)}`,
                      )}
                    >
                      {dc.t(s?.dir)}
                    </span>{' '}
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',
                        fontSize: '10.5px',
                        color: 'var(--acc-2)',
                      }}
                    >
                      <i className="ph ph-sparkle" style={{ fontSize: '11px' }}></i>
                      {dc.t(s?.confLabel)}
                      {' confidence'}
                    </span>{' '}
                    {s?.lowConf ? (
                      <>
                        {' '}
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '5px',
                            fontSize: '10px',
                            padding: '2px 9px',
                            borderRadius: '99px',
                            border: '1px solid color-mix(in srgb, var(--amb) 40%, transparent)',
                            color: 'var(--amb-2)',
                          }}
                        >
                          <i className="ph ph-warning" style={{ fontSize: '11px' }}></i>Below your 70% floor
                        </span>{' '}
                      </>
                    ) : null}{' '}
                    <div style={{ flex: '1' }}></div>{' '}
                    <button
                      className="scp-b63fab2"
                      onClick={s?.dismiss}
                      title={`Dismiss ${dc.s(s?.sym)} signal`}
                      aria-label={`Dismiss ${dc.s(s?.sym)} signal`}
                      style={{
                        fontSize: '11px',
                        padding: '5px 14px',
                        borderRadius: '99px',
                        border: '1px solid var(--l12)',
                        background: 'transparent',
                        color: 'var(--muted2)',
                        cursor: 'pointer',
                      }}
                    >
                      Dismiss
                    </button>{' '}
                    <button
                      className="scp-e4b4ff0"
                      onClick={s?.accept}
                      title={`Load ${dc.s(s?.sym)} into the order ticket`}
                      aria-label={`Load ${dc.s(s?.sym)} into the order ticket`}
                      style={{
                        fontSize: '11px',
                        fontWeight: '500',
                        padding: '5px 14px',
                        borderRadius: '99px',
                        border: '1px solid color-mix(in srgb, var(--pos) 50%, transparent)',
                        background: 'color-mix(in srgb, var(--pos) 8%, transparent)',
                        color: 'var(--pos)',
                        cursor: 'pointer',
                      }}
                    >
                      Accept → TradeHub
                    </button>{' '}
                  </div>{' '}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))',
                      gap: '10px',
                      marginTop: '12px',
                    }}
                  >
                    {' '}
                    <div style={{ border: '1px solid var(--l8)', borderRadius: '11px', padding: '9px 12px' }}>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Entry
                      </div>
                      <div
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          marginTop: '3px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(s?.entry)}
                      </div>
                    </div>{' '}
                    <div style={{ border: '1px solid var(--l8)', borderRadius: '11px', padding: '9px 12px' }}>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Stop loss
                      </div>
                      <div
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          marginTop: '3px',
                          color: 'var(--neg)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(s?.sl)}
                      </div>
                    </div>{' '}
                    <div style={{ border: '1px solid var(--l8)', borderRadius: '11px', padding: '9px 12px' }}>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        Take profit
                      </div>
                      <div
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          marginTop: '3px',
                          color: 'var(--pos)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(s?.tp)}
                      </div>
                    </div>{' '}
                    <div style={{ border: '1px solid var(--l8)', borderRadius: '11px', padding: '9px 12px' }}>
                      <div
                        style={{
                          fontSize: '9px',
                          letterSpacing: '0.11em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        R : R
                      </div>
                      <div
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          marginTop: '3px',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(s?.rr)}
                      </div>
                    </div>{' '}
                  </div>{' '}
                  <div
                    style={{
                      fontSize: '11.5px',
                      color: 'var(--muted)',
                      lineHeight: '1.6',
                      marginTop: '11px',
                    }}
                  >
                    {dc.t(s?.note)}
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.sgNone ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '38px 20px',
              textAlign: 'center',
            }}
          >
            {' '}
            <i className="ph ph-radio-button" style={{ fontSize: '28px', color: 'var(--ghost)' }}></i>{' '}
            <div style={{ fontSize: '13px', color: 'var(--text-mid)', marginTop: '10px' }}>
              No active signals
            </div>{' '}
            <div style={{ fontSize: '11.5px', color: 'var(--faint)', marginTop: '4px' }}>
              Nothing clears your confidence filter right now.
            </div>{' '}
            <button
              className="scp-2223d55"
              onClick={m.sgRestore}
              title="Restore dismissed signals"
              aria-label="Restore dismissed signals"
              style={{
                marginTop: '14px',
                fontSize: '11.5px',
                padding: '7px 15px',
                borderRadius: '99px',
                border: '1px solid var(--l12)',
                background: 'transparent',
                color: 'var(--text-mid)',
                cursor: 'pointer',
              }}
            >
              Restore dismissed
            </button>{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
